<ng-template #formBody>
  @let form = reviewFormService.form;

  <app-review-form-suspected-theft [form]="form"></app-review-form-suspected-theft>

  @if (reviewFormService.form.controls.isTheft.value) {
    <div class="flex flex-col md:flex-row gap-2">
      <div class="flex-1">
        <app-review-form-incident-date
          [form]="form"
          [timezone]="locationTimezone()"
          [displayTimezone]="true"
        ></app-review-form-incident-date>

        <app-review-form-incident-type [form]="form"></app-review-form-incident-type>

        <app-review-form-template [incidentForm]="form" [form]="reviewFormService.findingsForm"></app-review-form-template>

        <app-review-form-value-additional-stolen-items [form]="form"></app-review-form-value-additional-stolen-items>

        <app-review-form-incident-photos
          [imageUrls]="reviewFormService.uniqueInstancePhotoUrls()"
          (upload)="reviewFormService.onPhotosFileUpload($event)"
        ></app-review-form-incident-photos>

        <app-review-form-transaction-reports
          [imageUrls]="reviewFormService.uniqueTransactionPhotoUrls()"
          [form]="form"
          [isRequired]="false"
          (upload)="reviewFormService.processReportsFileEvent($event)"
        ></app-review-form-transaction-reports>

        <app-review-form-extra-links [form]="form"></app-review-form-extra-links>
      </div>

      <app-review-form-suspicious-incident-report-options
        class="block flex-1"
        [form]="form"
        [caseImages]="reviewFormService.caseImages()"
        [isLoadingCaseImages]="reviewFormService.isLoadingCaseImages()"
      ></app-review-form-suspicious-incident-report-options>
    </div>

    <app-review-form-errors-inline-alert [form]="form"></app-review-form-errors-inline-alert>
  } @else {
    <app-review-form-ntf-reason [form]="reviewFormService.findingsForm"></app-review-form-ntf-reason>
  }
</ng-template>

@if (isLoading()) {
  <app-pan-blank-slate>
    <app-pan-spinner></app-pan-spinner>
    &nbsp;Loading...
  </app-pan-blank-slate>
}

<div class="flex flex-row max-xl:flex-col" [class.flex-wrap]="videoExpanded()">
  <div class="p-4" [ngClass]="videoExpanded() ? 'basis-full' : 'basis-1/2'">
    @if (videoClips().length > 0) {
      <app-pan-card header="Videos">
        <app-review-video-clips [videoClips]="videoClips()" (expandedChange)="videoExpanded.set($event)"></app-review-video-clips>
      </app-pan-card>
    }
    @if (reviewFormService.initialInstancePhotoUrls().length > 0) {
      <app-pan-card header="Photos">
        @for (photo of reviewFormService.initialInstancePhotoUrls(); track photo) {
          <div class="flex justify-center items-center">
            <img [src]="photo" alt="Additional photo" class="block max-w-full max-h-[50vh]" data-testid="instancePhoto" />
          </div>
        }
      </app-pan-card>
    }
    @if (reviewFormService.initialTransactionPhotoUrls().length > 0) {
      <app-pan-card header="Transaction Reports">
        @for (report of reviewFormService.initialTransactionPhotoUrls(); track report) {
          <div class="flex justify-center items-center">
            <img [src]="report" alt="Transactions report image" class="block max-w-full max-h-[50vh]" data-testid="reportImage" />
          </div>
        }
      </app-pan-card>
    }
  </div>
  <div class="basis-1/2 p-4 gap-8">
    @if (timelineRows().length > 0) {
      <app-pan-card header="Timeline">
        <app-incident-timeline-table [rows]="timelineRows()"></app-incident-timeline-table>
      </app-pan-card>
    }

    <app-pan-card header="Cameras">
      @for (camera of liveCameras(); track camera; let i = $index) {
        <a
          panButton
          type="button"
          target="_blank"
          class="mr-2"
          [href]="camera.live_stream_link"
          [attr.data-testid]="'cameraLink' + (i + 1)"
        >
          Camera {{ i + 1 }}
        </a>
      } @empty {
        <app-pan-inline-alert type="warning">
          There's no cameras configured for this location in Panoptyc App. Please use the branch and location information to look up the
          camera manually.
        </app-pan-inline-alert>
      }
    </app-pan-card>

    @if (location()) {
      <app-pan-card header="Location Info">
        Branch: {{ location()?.branch_name }}<br />
        Location: {{ location()?.name }}<br />
        <span class="text-xs"> (branch_id: {{ location()?.branch_id }}, location_id: {{ location()?.id }}) </span>
      </app-pan-card>
    }

    @if (instructions() && instructions()?.length > 0) {
      <app-pan-card header="Instructions">
        <textarea panTextarea readonly rows="12" data-testid="instructions" value="{{ instructions() }}"> </textarea>
      </app-pan-card>
    }

    @if (notes() && notes()?.length > 0) {
      <app-pan-card header="Notes">
        <textarea panTextarea readonly rows="12" data-testid="notes" value="{{ notes() }}"> </textarea>
      </app-pan-card>
    }

    @let reviewId = assignmentDetailsStore.details()?.assignment_id;
    @if (reviewId) {
      <app-pan-card header="Additional Info">
        <app-pan-form-control class="flex-1">
          <app-pan-floating-label>Review ID</app-pan-floating-label>
          <input panInput readonly [value]="reviewId" />
        </app-pan-form-control>
      </app-pan-card>
    }
  </div>
</div>
